import React, {useContext, useState} from 'react';
import WCLoginService from '../services/WCLoginService';
import PasswordChangeForm from "./PasswordChangeForm";
import {LoaderDispatch} from "../context/LoaderContext";

const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const lodaerDispatch = useContext(LoaderDispatch);
    const handleCheckEmail = async (e) => {
        lodaerDispatch({type: 'activate'});
        e.preventDefault();
        setMessage(null);
        setError(null);

        const response = await WCLoginService.resetPasswordEmail(email);

        if(response.status === 'error') {
            setError(response.message);
        } else {
            setMessage(response.message);
            setToken(response.token);
        }
        lodaerDispatch({type: 'deactivate'});
        //console.log(response);
    };

    const handleResetPassword = async (e) => {
        if (password !== confirmPassword) {
            setError('Podane hasła nie są identyczne.');
            return;
        }

    }

    return (
        <div className="row justify-content-center">
            <div className="col-12 col-md-8">
                <form onSubmit={ !token ? handleCheckEmail : handleResetPassword} aria-label="Formularz resetowania hasła">
                    {!token ? (
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                aria-required="true"
                                aria-label="Email"
                                autoComplete="email"
                            />
                        </div>
                    ) : (
                        <PasswordChangeForm
                            password={password}
                            confirmPassword={confirmPassword}
                            setPassword={setPassword}
                            setConfirmPassword={setConfirmPassword}
                        />
                    )}
                    <div className="row">
                        <button className="btn btn--secondary" style={{margin: "2rem auto"}} type="submit" aria-label="Resetuj hasło">Reset Password</button>
                    </div>
                    {message && <div className="alert alert-success mt-3" role="alert">{message}</div>}
                    {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
                    <div className="mb-3"></div>
                </form>
            </div>
        </div>


    );
};

export default ResetPassword;
